export const READ_ALOUD_SPEEDS = {
  "25%": {
    label: "1x",
    value: "25%",
  },
  "50%": {
    label: "2x",
    value: "50%",
  },
  "75%": {
    label: "3x",
    value: "75%",
  },
  "100%": {
    label: "4x",
    value: undefined, // Endpoint default, request will fail if 100% is passed.
  },
};
